import gql from 'graphql-tag';

export default gql`
  mutation AddBloodSugarMeasurementMutation($request: BloodSugarMeasurementInputType!) {
    diabetes {
      createBloodSugarMeasurement(request: $request) {
        __typename
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;
